import { Tooltip, Modal, Collapse } from 'bootstrap';
import { tmpl } from './lib/tmpl';
import { appendTo } from './lib/helpers';
import initAjaxForms from './lib/forms';
import Cookies from 'js-cookie';
import 'lazysizes';

// icons - common
import './sprites/icon/search.svg';
import './sprites/icon/map-pin.svg';
import './sprites/icon/user.svg';
import './sprites/icon/traffic-cone.svg';
import './sprites/icon/message-lines.svg';
import './sprites/icon/receipt.svg';
import './sprites/icon/badge-check.svg';
import './sprites/icon/circle-question.svg';
import './sprites/icon/arrow-right-from-bracket.svg';
import './sprites/icon/chevron-up.svg';
import './sprites/icon/stethoscope.svg';
import './sprites/icon/desktop.svg';
import './sprites/icon/camera.svg';
import './sprites/icon/chevron-right.svg';
import './sprites/icon/chevron-left.svg';
import './sprites/icon/user.svg';
import './sprites/icon/eye.svg';
import './sprites/icon/eye-slash.svg';
import './sprites/icon/envelope.svg';
// icons - paper
import './sprites/icon/arrow-left.svg';
import './sprites/icon/print.svg';
import './sprites/logo/black.svg';
// icons - school
import './sprites/icon/stethoscope.svg';
import './sprites/icon/desktop.svg';
import './sprites/icon/camera.svg';
import './sprites/icon/list-check.svg';
import './sprites/icon/building.svg';
import './sprites/icon/car-bump.svg';
import './sprites/icon/angle-up.svg';
// nomer
import './sprites/icon/copy.svg';
// article
import './sprites/icon/grid.svg';
import './sprites/icon/list.svg';
import './sprites/icon/book.svg';
// admin
import './sprites/icon/pen-to-square.svg';

// brands
import './sprites/brand/vk.svg';
import './sprites/brand/yandex.svg';
import './sprites/brand/telegram.svg';
import './sprites/brand/odnoklassniki.svg';
import './sprites/brand/twitter.svg';
import './sprites/brand/web.svg';
import './sprites/brand/facebook.svg';
import './sprites/brand/instagram.svg';
import './sprites/brand/youtube.svg';
import './sprites/brand/dzen.svg';

const testWebP = () => {
    const webP = new Image();
    // eslint-disable-next-line no-multi-assign,func-names
    webP.onload = webP.onerror = function () {
        if (webP.height === 2) {
            document.querySelector('html')
                .classList
                .add('webp');
        } else {
            document.querySelector('html')
                .classList
                .add('no-webp');
        }
    };
    webP.src = 'data:image/webp;base64,UklGRjoAAABXRUJQVlA4IC4AAACyAgCdASoCAAIALmk0mk0iIiIiIgBoSygABc6WWgAA/veff/0PP8bA//LwYAAA';
};

/**
 * Submit review form
 * @param data
 */
const submitReview = (data = {}) => {
    const reviewForm = document.querySelector('#review-form');

    // Add data to form
    for (const key in data) {
        if (!data.hasOwnProperty(key)) continue;

        const viaInput = document.createElement('input');

        viaInput.type = 'hidden';
        viaInput.name = key;
        viaInput.value = data[key];

        reviewForm.appendChild(viaInput);
    }
    // and submit
    reviewForm.dispatchEvent(new Event('submit'));
};

// Open popup at screen center
const popupCenter = ({
    url,
    title,
    w,
    h,
}) => {
    // Fixes dual-screen position                             Most browsers      Firefox
    const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
    const dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screenY;

    const width = window.innerWidth ? window.innerWidth : (document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width);
    const height = window.innerHeight ? window.innerHeight : (document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height);

    const systemZoom = width / window.screen.availWidth;
    const left = (width - w) / 2 / systemZoom + dualScreenLeft;
    const top = (height - h) / 2 / systemZoom + dualScreenTop;
    const newWindow = window.open(
        url,
        title,
        `
      scrollbars=yes,
      width=${w / systemZoom}, 
      height=${h / systemZoom}, 
      top=${top}, 
      left=${left}
      `,
    );

    if (window.focus) newWindow.focus();
};

const setSignUpType = (type) => {
    if (type === 'register') {
        document.querySelector('.sign-up-title').innerHTML = 'Регистрация';
        document.querySelector('.sign-up-reg')
            .classList
            .remove('d-none');
        document.querySelector('.sign-up-social')
            .classList
            .add('d-none');
        document.querySelector('.sign-up-login')
            .classList
            .add('d-none');
        document.querySelector('.sign-up-modal')
            .classList
            .add('reg-modal');
        document.querySelector('.sign-up-modal')
            .classList
            .remove('sign-modal');
    } else if (type === 'login') {
        document.querySelector('.sign-up-title').innerHTML = 'Вход с паролем';
        document.querySelector('.sign-up-reg')
            .classList
            .add('d-none');
        document.querySelector('.sign-up-social')
            .classList
            .add('d-none');
        document.querySelector('.sign-up-login')
            .classList
            .remove('d-none');
        document.querySelector('.sign-up-modal')
            .classList
            .remove('reg-modal');
        document.querySelector('.sign-up-modal')
            .classList
            .add('sign-modal');
    } else {
        document.querySelector('.sign-up-title').innerHTML = 'Вход';
        document.querySelector('.sign-up-reg')
            .classList
            .add('d-none');
        document.querySelector('.sign-up-social')
            .classList
            .remove('d-none');
        document.querySelector('.sign-up-login')
            .classList
            .add('d-none');
        document.querySelector('.sign-up-modal')
            .classList
            .remove('reg-modal');
        document.querySelector('.sign-up-modal')
            .classList
            .add('sign-modal');
    }
};

const delay = (delayInms) => {
    return new Promise(resolve => setTimeout(resolve, delayInms));
};

let searchTimeout = null;

const doDelayedSearch = (query) => {
    if (searchTimeout) {
        clearTimeout(searchTimeout);
    }
    searchTimeout = setTimeout(function () {
        const searchContainer = document.getElementById('search-container');

        const searchArticlePlaceholderRenderer = tmpl(document.getElementById('search-article-placeholder').innerHTML);
        const searchSchoolPlaceholderRenderer = tmpl(document.getElementById('search-school-placeholder').innerHTML);

        searchContainer.innerHTML = '';

        if (query.length > 2) {
            appendTo(searchContainer, searchArticlePlaceholderRenderer({ placeholder: true }));
            appendTo(searchContainer, searchSchoolPlaceholderRenderer({ placeholder: true }));
            appendTo(searchContainer, searchArticlePlaceholderRenderer({ placeholder: true }));
            appendTo(searchContainer, searchSchoolPlaceholderRenderer({ placeholder: true }));

            fetch(`/api/v1/search/suggest?q=${query}`)
                .then((response) => response.json())
                .then((response) => {
                    /**
                     * @typedef {Array} response
                     */
                    if (response.length > 0) {
                        searchContainer.innerHTML = '';

                        response.forEach((item) => {
                            /**
                             * @typedef {Object} item
                             * @property {String} lqip
                             * @property {String} thumbnail
                             * @property {String} title
                             * @property {Object} section
                             */
                            if (item.type === 'article' || item.type === 'pdd') {
                                appendTo(searchContainer, searchArticlePlaceholderRenderer(item));
                            } else if (item.type === 'school') {
                                appendTo(searchContainer, searchSchoolPlaceholderRenderer(item));
                            }
                        });

                        appendTo(searchContainer, `<div class="col-12 text-center"><a href="/search/?q=${query}" class="btn btn-primary">все результаты</a></div>`);
                    } else {
                        searchContainer.innerHTML = `<div class="text-center fs-3 text-muted opacity-75">Ничего не удалось найти.<br>Попробуйте переформулировать запрос</div>`;
                    }
                });
        }
    }, 500);
};

testWebP();

window.addEventListener('load', () => {
    const preloader = document.querySelector('.preloader');

    if (preloader) {
        setTimeout(() => {
            preloader.style.opacity = '0';
            preloader.addEventListener('transitionend', () => preloader.remove());
        }, 200);
    }
});

document.addEventListener('DOMContentLoaded', () => {
    initAjaxForms();

    const searchOffcanvas = document.getElementById('searchOffcanvas');
    if (searchOffcanvas) {
        const searchInput = document.getElementById('search-input');

        searchOffcanvas.addEventListener('shown.bs.offcanvas', function () {
            searchInput.focus();
        });
        searchOffcanvas.addEventListener('hidden.bs.offcanvas', function () {
            searchInput.blur();
        });

        searchInput.addEventListener('input', (e) => {
            doDelayedSearch(e.currentTarget.value || '');
        });
    }

    /**
     * Cookie notifier
     */
    if (!Cookies.get('cookie-is-okay')) {
        setTimeout(() => {
            const cookieJar = document.createElement('div');
            cookieJar.classList.add('cookie', 'position-fixed', 'rounded', 'shadow', 'small');
            cookieJar.innerHTML = [
                '<div class="d-flex">',
                '<div class="lh-sm">',
                'Мы сохраняем «куки» <a href="/info/cookie/">по правилам</a>, чтобы персонализировать сайт. ',
                'Вы можете запретить это в настройках браузера.',
                '</div>',
                '<div class="ms-1"><button class="btn btn-primary btn-sm px-3" id="btn-cookie-ok">OK</button></div>',
                '</div>',
            ].join('');
            document.querySelector('body')
                .appendChild(cookieJar);

            document.getElementById('btn-cookie-ok')
                .addEventListener('click', () => {
                    Cookies.set('cookie-is-okay', 'Y', {
                        expires: 3650,
                        domain: '.avtobeginner.ru'
                    });
                    cookieJar.style.display = 'none';
                });
        }, 400);
    }

    /**
     * Scroll to top toggle
     */
    const scrollToHome = document.querySelector('.scrollToHome');
    if (scrollToHome) {
        window.addEventListener('scroll', () => {
            if (window.scrollY > 600) {
                scrollToHome.classList
                    .add('visible');
            } else {
                scrollToHome
                    .classList
                    .remove('visible');
            }
        });
        scrollToHome
            .addEventListener('click', (e) => {
                e.preventDefault();
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth',
                });
            });
    }

    /**
     * Tooltips
     */
    const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
    tooltipTriggerList.map((tooltipTriggerEl) => new Tooltip(tooltipTriggerEl));

    // Close feedback on success
    document.addEventListener('close-feedback', () => {
        const feedbackModal = document.getElementById('feedback-modal');
        // If review modal is open
        if (feedbackModal && feedbackModal.classList.contains('show')) {
            const feedbackModalInstance = Modal.getOrCreateInstance(feedbackModal);
            feedbackModalInstance.hide();
        }
    });

    /**
     * Menu
     */
    const header = document.querySelector('.header');

    if (header) {
        const mainMenu = document.getElementById('mainMenu');
        const mainMenuToggler = document.querySelector('.navbar-toggler');
        const mainMenuCollapse = new Collapse(mainMenu, { toggle: false });

        // Little trick for smooth and slow menu animation
        mainMenuToggler.addEventListener('click', async () => {
            // eslint-disable-next-line no-underscore-dangle
            if (!mainMenuCollapse._isShown()) {
                header.classList.add('expanded');
                // Do not forget to sync delay with css property
                await delay(200);
            }

            mainMenuCollapse.toggle();
        });
        mainMenu.addEventListener('hidden.bs.collapse', () => {
            header.classList.remove('expanded');
        });
    }

    /**
     * Locations
     */
    // More regions in region selector
    if (document.getElementById('geo-city-selector-more')) {
        document.getElementById('geo-city-selector-more')
            .addEventListener('click', (e) => {
                e.preventDefault();

                const moreRegionsCont = document.getElementById('geo-city-selector-more-cont');
                if (moreRegionsCont) {
                    moreRegionsCont.classList.remove('d-none');
                    e.target.style.display = 'none';
                }
            });
    }

    // Domain choose in region modal
    document.querySelectorAll('.geo-city-selector')
        .forEach((link) => {
            link.addEventListener('click', (e) => {
                e.preventDefault();
                if (e.currentTarget.dataset.url) {
                    window.location.href = e.currentTarget.dataset.url;
                }
            });
        });

    /**
     * Sign Up Form
     */
    document.querySelectorAll('.sign-up-mode')
        .forEach((link) => {
            link.addEventListener('click', (e) => {
                e.preventDefault();
                setSignUpType(e.target.dataset.mode);
            });
        });

    // Sign-up | Login modal
    const signUpModal = document.getElementById('sign-up-modal');

    if (signUpModal) {
        const reviewModal = document.getElementById('review-modal');
        const signUpModalInstance = Modal.getOrCreateInstance(signUpModal);

        signUpModal.addEventListener('show.bs.modal', (e) => {
            document.getElementById('reg-type').value = '';

            if (e.relatedTarget) {
                if ('mode' in e.relatedTarget.dataset) {
                    setSignUpType(e.relatedTarget.dataset.mode);
                }
                if ('regType' in e.relatedTarget.dataset) {
                    document.getElementById('reg-type').value = e.relatedTarget.dataset.regType;
                }
            }
            if (reviewModal) {
                reviewModal.classList.add('modal-off');
            }
        });
        signUpModal.addEventListener('hide.bs.modal', () => {
            if (reviewModal) {
                reviewModal.classList.remove('modal-off');
            }
        });

        // Success login
        document.addEventListener('login-success', (e) => {
            // If review modal is open
            if (reviewModal && reviewModal.classList.contains('show')) {
                // hide login form
                signUpModalInstance.hide();
                // and submit review form
                submitReview(e.detail);
            } else {
                // Otherwise just reload
                window.location.reload();
            }
        });

        // Success registration
        document.addEventListener('reg-success', (e) => {
            // If review modal is open
            if (reviewModal && reviewModal.classList.contains('show')) {
                // hide login form
                signUpModalInstance.hide();
                // and submit review form
                submitReview(e.detail);
            } else {
                window.location.href = '/registration/done/';
            }
        });

        // Failed login
        document.addEventListener('login-fail', (e) => {
            const socialAuthContainer = document.querySelector('.sign-up-social');
            let alert = socialAuthContainer.querySelector('.alert');

            if (!alert) {
                alert = document.createElement('div');
                alert.classList.add('alert', 'alert-danger');

                socialAuthContainer.insertBefore(alert, socialAuthContainer.firstChild);
            }

            alert.textContent = 'Не удалось авторизоваться через соц. сеть. Попробуйте позднее.';

            if ('via' in e.detail) {
                const button = document.querySelector('.sign-up-social')
                    .querySelector(`.btn-${e.detail.via}`);
                if (button) {
                    button.classList.add('btn-danger');
                }
            }
        });

        if (typeof needAuth !== 'undefined' && needAuth === true) {
            signUpModal.querySelector('.btn-close').style.display = 'none';

            // eslint-disable-next-line no-underscore-dangle
            signUpModalInstance._config.backdrop = 'static';
            // eslint-disable-next-line no-underscore-dangle
            signUpModalInstance._config.keyboard = false;
            signUpModalInstance.show();
        }
    }

    // Success logout
    document.addEventListener('logout-success', () => {
        window.location.reload();
    });

    // Show/Hide password
    document.querySelectorAll('.password-mode')
        .forEach((button) => {
            button.addEventListener('click', (e) => {
                e.preventDefault();

                const group = e.target.closest('.form-group');
                const input = group.querySelector('input');

                if (input.getAttribute('type') === 'password') {
                    input.setAttribute('type', 'text');
                    group.classList.remove('masked');
                } else {
                    input.setAttribute('type', 'password');
                    group.classList.add('masked');
                }
            });
        });

    // Social auth
    document.querySelectorAll('.social-auth')
        .forEach((link) => {
            link.addEventListener('click', (e) => {
                e.preventDefault();

                popupCenter({
                    url: `/oauth/?provider=${link.dataset.provider}`,
                    title: 'social-auth',
                    w: link.dataset.width,
                    h: link.dataset.height,
                });
            });
        });

    /**
     * More articles
     */
    document.querySelectorAll('.more-articles')
        .forEach((container) => {
            container.addEventListener('click', (e) => {
                e.preventDefault();

                const button = e.currentTarget;
                const container = document.getElementById(button.dataset.target);
                const placeholderRenderer = tmpl(document.getElementById('more-placeholder').innerHTML);

                for (let i = 1; i < 9; i += 1) {
                    appendTo(container, placeholderRenderer({ placeholder: true }));
                }

                // compose query string
                const query = [];
                for (let key in button.dataset) {
                    if (key.startsWith('filter')) {
                        query.push(`${key.replace('filter', '')
                            .toLowerCase()}=${button.dataset[key]}`);
                    }
                }
                query.push(`page=${button.dataset.page}`);

                fetch(`/api/v2/articles/${button.dataset.type}/?${query.join('&')}`)
                    .then((response) => response.json())
                    .then((response) => {
                        /**
                         * @typedef {Array} response
                         */
                        if (response.data.length > 0) {
                            const slugs = container.getElementsByClassName('placeholder-glow');
                            while (slugs[0]) {
                                slugs[0].parentNode.removeChild(slugs[0]);
                            }

                            response.data.forEach((item) => {
                                /**
                                 * @typedef {Object} item
                                 * @property {String} lqip
                                 * @property {String} thumbnail
                                 * @property {String} title
                                 * @property {Object} section
                                 */
                                appendTo(container, placeholderRenderer(item));
                            });

                            button.dataset.page = `${parseInt(button.dataset.page, 10) + 1}`;
                        }

                        if (response.data.length < 8) {
                            button.style.display = 'none';
                        }
                    });

                button.blur();
            });
        });
});
